import type { PageLoad } from './$types';
import { routesPagename } from '$lib/services/urls/routesPagename';
import { enrichPoisStoreWithSelectedPoiData } from '$routes/(map)/loadPois';
import { getCorridorData } from '$routes/(map)/routes/(details)/on-the-way/loadCorridorData';

export const load = (async (event) => {
	const { itineraryResultsStore, searchParams } = await event.parent();
	const { selectedPoi } = searchParams;

	const { poisStore: poisStoreWithoutSelectedPoiData, corridorPolygonStore }
		= await getCorridorData({
			event,
			searchParams,
			itineraryResultsStore,
		});

	const poisStore = await enrichPoisStoreWithSelectedPoiData(
		poisStoreWithoutSelectedPoiData,
		selectedPoi,
		event,
	);

	return {
		corridorPolygonStore,
		poisStore,
		mobileTopButtons: ['back-on-the-way'],
		pagename: selectedPoi ? routesPagename[`${selectedPoi.type}_DATASHEET`] : undefined,
		isTopLevelPage: false,
	};
}) satisfies PageLoad;
